import { useEffect, useState } from 'react';

/**
 * Hook that detects any scroll movement on the page
 * Returns true when user has scrolled away from the very top (scrollY > 0)
 * Returns false when user is at the very top (scrollY === 0)
 */
export const useScrollDetection = () => {
  // Initialize with actual scroll position to prevent flash
  const [hasScrolled, setHasScrolled] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.scrollY > 0;
    }

    return false;
  });

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setHasScrolled(scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return hasScrolled;
};
